import i18n from 'i18n';

// Import helpers
import { openNotification } from 'components/utilities/notification/notification';
import { scrollToTop } from 'components/views/configurator/helpers';

const onErrorStep = (reason = null, duration = 10) => {
	scrollToTop();
	const title = i18n.t('configurator_errors_general_title');
	const description =
		reason ?? i18n.t('configurator_errors_general_description');
	openNotification({
		title,
		description,
		type: 'error',
		duration
	});
};

export default onErrorStep;
